export default "__VITE_ASSET__BdiHnVB$__"